import { render, staticRenderFns } from "./AttributesPanel.vue?vue&type=template&id=153d451a&scoped=true&"
import script from "./AttributesPanel.vue?vue&type=script&lang=js&"
export * from "./AttributesPanel.vue?vue&type=script&lang=js&"
import style0 from "./AttributesPanel.vue?vue&type=style&index=0&id=153d451a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d451a",
  null
  
)

export default component.exports